import React from 'react'
import { Button } from 'react-bootstrap'
import './Inputs.css'

interface IButtonProp {
  href?: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
  style?: React.CSSProperties
  className?: string
  children?: any
}

const BlueButton: React.FC<IButtonProp> = ({
  href,
  onClick,
  disabled,
  className,
  style,
  children,
}: IButtonProp) => {
  return (
    <Button
      type='button'
      className={'btn btn-blue btn-round ' + className}
      style={style}
      onClick={onClick}
      href={href}
      disabled={disabled}
    >
      {children}
    </Button>
  )
}
export default BlueButton
